import {
  BaseModal,
  Button,
  Content,
  Flex,
  fromTheme,
  IconButton,
  StrokeIcon,
} from '@acsbe/ui';
import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import cancelPlanHeader from '../../assets/cancelPlanPopup.svg';
import { useDomainSelection } from '../../context/DomainSelectionContext';
import { useMerchantSession } from '../../context/MerchantSessionContext';
import { Logger } from '../../utils/logger';

interface CancelPlanPopupProps {
  onClose: () => void;
}

export const CancelPlanPopup = (props: CancelPlanPopupProps) => {
  const { t } = useTranslation();

  const { licenseId } = useDomainSelection();
  const { merchantDetails } = useMerchantSession();
  const [processing, setProcessing] = useState(false);
  const { refreshLicenseDetails } = useDomainSelection();

  const onClose = () => {
    props.onClose();
  };

  const onCancelPlan = async () => {
    setProcessing(true);
    const response = await axios.post(
      `/api/cancel-plan/${merchantDetails?.source}`,
      {
        licenseId,
      },
      {
        withCredentials: true,
      },
    );
    Logger.log('cancel-plan-response', response);
    if (response.data?.success) {
      refreshLicenseDetails();
      setProcessing(false);
    }
    onClose();
  };

  return (
    <>
      <StyledModal open={true} closeButton>
        <Flex>
          <HeaderImage />
        </Flex>
        <CloseButton
          aria-label={t('CLOSE')!}
          padding={1.5}
          scale="alternative"
          variant="solid"
          radius="round"
          data-mixpanel="close-cancel-plan-modal"
          onClick={() => onClose()}
        >
          <StrokeIcon name="Close" size="lg" />
        </CloseButton>
        <Flex padding={8} paddingBlockStart={10} gap={8}>
          <Flex>
            <Flex gap={4}>
              <Heading>Cancel your plan?</Heading>
              <SubHeading>
                Cancelling the plan means your store may not be accessible.
                You’ll be forwarded to your apps manager
              </SubHeading>
            </Flex>
          </Flex>
          <Flex gap={4} justify="end" row>
            <KeepButton
              scale="ghost"
              onClick={() => onClose()}
              data-mixpanel="keep-plan-cancel-plan-modal"
              disabled={processing}
            >
              <span>Keep plan</span>
            </KeepButton>
            <Button
              scale="danger"
              onClick={() => onCancelPlan()}
              data-mixpanel="cancel-plan-cancel-plan-modal"
              disabled={processing}
            >
              <StrokeIcon name="SquareUpRightStroke" />
              <span>Cancel plan</span>
            </Button>
          </Flex>
        </Flex>
      </StyledModal>
    </>
  );
};

const KeepButton = styled(Button)`
  border: 1px solid #cbd2e1;
`;
const StyledModal = styled(BaseModal)`
  max-width: 520px;
`;
const HeaderImage = styled(cancelPlanHeader)`
  max-width: 100%;
  height: auto;
`;
const CloseButton = styled(IconButton)`
  position: absolute;
  inset-block-start: 5px;
  inset-inline-end: 5px;
  background-color: #e0eafe;
  background-color: transparent;
  color: #394c61;
`;
const Heading = styled(Flex)`
  font-size: 28px;
  font-weight: 700;
  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 22px;
  }
`;
const SubHeading = styled(Content)`
  font-size: 18px;
  line-height: 27px;
  @media ${fromTheme('viewport.uptoPhablet')} {
    font-size: 14px;
    line-height: 21px;
  }
`;
